import React from 'react';
// countup
import CountUp from 'react-countup';
//intersection obeserver hook
import { useInView } from 'react-intersection-observer';
//motion
import { motion } from 'framer-motion';
//variant
import { fadeIn } from '../variants';
import { Link } from 'react-router-dom';

const About = () => {
  const [ref, inView] = useInView({ threshold: 0.5, });


  return (
    <section className='section  ' id='about' ref={ref}>
      <div className='container mx-auto'>
        <div className='flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-screen'>

          {/* {img} */}
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial="hidden"
            whileInView={"show"}  
            viewport={{ once: false, amount: 0.3 }}

            className='flex-1 bg-about bg-contain bg-no-repeat h-[640px] mix-blend-lighten bg-top'>

          </motion.div>
          {/* {text} */}
          <motion.div
            variants={fadeIn('left', 0.5)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 text-center lg:text-start'>
            <h2 className='h2 text-accent'>About me.</h2>
            <h3 className='h3 mb-4'>Passionate Full Stack Developer
            </h3>
            <p className='mb-6 '>
              Creativity in crafting engaging user experiences and delivering high-quality web applications.


            </p>

            {/* {stat} */}
            <div className='flex gap-x-0 lg:gap-x-10 mb-12 justify-around  lg:justify-start '>
              <div className=''>
                <div className='text-[2rem] lg:text-[40px] font-tertiary text-gradient mb-2 '>
                  {inView ? <CountUp start={0} end={12} duration={4} /> : null}
                  k+
                </div>
                <div className='font-primary text-sm tracking-[0.5px]  sm:tracking-[2px]'>
                  Projects <br />
                  Completed
                </div>
              </div>
              <div>
                <div className='text-[2rem] md:text-[40px] font-tertiary text-gradient mb-2'>
                  {inView ? <CountUp start={0} end={10} duration={4} /> : null}
                </div>
                <div className='font-primary text-sm tracking-[0.5px] sm:tracking-[2px]'>
                  Technology <br />
                  mastered
                </div>
              </div>
              <div>
                <div className=' text-[2rem] md:text-[40px] font-tertiary text-gradient mb-2'>
                  {inView ? <CountUp start={0} end={10} duration={4} /> : null}
                </div>
                <div className='font-primary text-sm tracking-[0.5px]  sm:tracking-[2px]'>
                  Satisfied <br />
                  Clients
                </div>
              </div>
            </div>
            <div className='flex gap-x-8 justify-center lg:justify-start items-center'>
              <Link to='/my-resume'>
                <button className='btn btn-lg'>View my resume </button>
              </Link>

              <Link to='/my-blogs' className='text-gradient btn-link'>

                My Blogs
              </Link>
            </div>

          </motion.div>

        </div>

      </div>

    </section>


  )
};

export default About;
